export const getVoteCount = (vote_count: number, vote_total: number) => {
  if (vote_total === 0) return 0;
  else return Math.round(((vote_count || 0) / vote_total) * 100);
};
